jQuery.noConflict();
jQuery(document).ready(function(){ 
    if( $('.galeriemultilogo').length > 0 ) {
        $('.galeriemultilogo_carousel').owlCarousel({
            loop:true,
            nav:true,
            dots:false,
            items:1,
            responsive:{
                0:{
                    margin: 0
                },
                600:{
                    margin:0
                },
                1000:{
                    margin:0
                }
            }
        });
    }
});

